<template>
	<modal
		size="small-medium"
		:hide-footer="true"
		@close="close">
		<template slot="header">
			<span>{{ $t('Generate Invitation Link') }}</span>
		</template>
		<template slot="body">
			<form @submit.prevent="save">
				<!-- Role -->
				<div class="form-group select">
					<label>{{ $t('Role') }}</label>
					<div class="mh-40px">
						<multiselect class="select-input" v-model="role" deselect-label="Can't remove this value" track-by="label" label="label"
						placeholder=" " :options="roles" :searchable="false" :allow-empty="false" :show-labels="false">
						<span class="arrow-multiselect" slot="caret">
							<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
						</span>
						</multiselect>
					</div>
				</div>
				<!-- Output Ids -->
				<div class="form-group rundown-collab">
					<label class="typo__label">Outputs</label>
					<div>
						<multiselect class="rundown-collab-input" v-model="outputIds" tag-placeholder=""
						placeholder="Search or add a Output" label="name" track-by="id"
						:options="outputs" :multiple="true" :searchable="true" :show-labels="false">
						<span class="arrow-multiselect" slot="caret">
								<i class="material-icons pb-1 mt-2 ml-2 size-arrow">expand_more</i>
						</span>
						<span slot="noResult">Oops! No Output found.</span>
						</multiselect>
					</div>
				</div>
				<!-- Rundown Ids -->
				<div class="form-group rundown-collab" v-if="activeRouteName !== 'dashboard' && activeRouteName !== 'Rundowns'">
					<label class="typo__label">Rundowns</label>
					<div>
						<multiselect class="rundown-collab-input" v-model="rundownIds" tag-placeholder=""
						placeholder="Search or add a Rundown" label="name" track-by="id"
						:options="filteredRundown" :multiple="true" :searchable="true" :show-labels="false">
						<span class="arrow-multiselect" slot="caret">
								<i class="material-icons pb-1 mt-2 ml-2 size-arrow">expand_more</i>
						</span>
						<span slot="noResult">Oops! No Rundown found.</span>
						</multiselect>
					</div>
				</div>
				<!-- Submit -->
				<button
					:disabled="!isValid"
					type="submit"
					class="btn btn-submit btn-primary mt-3"
					:class="{ 'is-loading': isSaving }">
					<span>{{ $t('Generate Link') }}</span>
				</button>
			</form>
		</template>
	</modal>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';
import Modal from '@/components/Modal.vue';
import { getAxiosErrorMessage } from '@/lib/helper';
import collaboratorsApi from '@/api/collaborators';
import rundownsApi from '@/api/rundowns';
import displaysApi from '@/api/displays';

export default {
	name: 'CollaboratorInvitationForm',
	props: {
		data: {
			type: Object,
		},
		rundown: {
			type: Object,
		},
	},
	components: {
		Modal,
		Multiselect,
	},
	data() {
		return {
			role: 'operator',
			roles: [
				{ key: 'event_manager', label: 'Creator' },
				{ key: 'operator', label: 'Operator' },
			],
			isSaving: false,
			rundowns: [],
			rundownIds: [],
			outputs: [],
			outputIds: [],
			isFetching: false,
			isFetchingOutput: false,
		};
	},
	methods: {
		fetchRundown() {
			this.isFetching = true;
			const callback = (response) => {
				const items = response.data;
				this.rundowns = items;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t(this.title),
					text: message,
				});
				this.isFetching = false;
			};
			const paramsRundown = {
				page: 1,
				limit: 1000,
				order_by: 'id',
				sort_by: 'asc',
				is_archived: 1,
				user_id: this.user.id,
			};
			rundownsApi.getList(paramsRundown, callback, errorCallback);
		},
		fetchOutput() {
			this.isFetchingOutput = true;
			const callback = (response) => {
				const items = response.data;
				this.outputs = items;
				this.isFetchingOutput = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t(this.title),
					text: message,
				});
				this.isFetchingOutput = false;
			};
			const paramsOutput = {
				page: 1,
				limit: 1000,
				order_by: 'id',
				sort_by: 'asc',
				is_mine: true,
			};
			displaysApi.getList(paramsOutput, callback, errorCallback);
		},
		save() {
			this.isSaving = true;
			const params = this.params;
			const callback = (response) => {
				const data = response.data;
				this.$emit('generated', data);
				this.isSaving = false;
				this.close();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add User',
					text: message,
				});
				this.isSaving = false;
			};
			collaboratorsApi.generateLink(params, callback, errorCallback);
		},
		close() {
			this.$emit('close');
		},
		reset() {
			this.role = this.roles[0];
			this.rundownIds = '';
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		userId() {
			return this.user && this.user.id ? this.user.id : '';
		},
		params() {
			const rundowns = [];
			const outputs = [];
			for (let index = 0; index < this.rundownIds.length; index++) {
				const id = this.rundownIds[index].id;
				rundowns.push(id);
			}
			for (let indexOutput = 0; indexOutput < this.outputIds.length; indexOutput++) {
				const idOutput = this.outputIds[indexOutput].id;
				outputs.push(idOutput);
			}
			// const access = this.access;
			const params = {
				role: this.role.key,
				rundown_ids: JSON.stringify(rundowns),
				display_ids: JSON.stringify(outputs),
			};
			if (this.activeRouteName === 'dashboard' || this.activeRouteName === 'Rundowns') {
				const id = this.rundown && this.rundown.id ? this.rundown.id : '';
				params.rundown_ids = `[${id}]`;
			}
			return params;
		},
		roleUser() {
			const role = JSON.parse(this.user.roles);
			return role;
		},
		filteredRundown() {
			const filter = item => (item.is_disabled !== 1);
			return this.rundowns.filter(filter);
		},
		isValid() {
			if (this.activeRouteName !== 'dashboard' && this.activeRouteName !== 'Rundowns') {
				return this.rundownIds.length !== 0;
			}
			return this.role.length !== 0;
		},
		activeRouteName() {
			return this.$route.name;
		},
	},
	created() {
		this.role = this.roles[0];
		this.fetchRundown();
		this.fetchOutput();
	},
	watch: {
	},
};
</script>
